import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Observation from '../../../../../../components/Advanced/Modal/PatientModal/Observations';

const statusMoods = [
  'NOT OUR PATIENT', 'ALREADY HAS AN APPOINTMENT', 'OPEN', 'INSURANCE CHANGED', 'OTHER PCP', 'PENDING', 'REFUSED'
]

const PCPChangesDetail = ({ modificar = {}, onSave}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [comments, setComments] = useState(modificar.ReleatedComments || []);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [newComment, setNewComment] = useState('');
  const timestamp = new Date().toLocaleString(); 

  const [form, setForm] = useState({
    memberId: modificar.memberId,
    insuranceStatus: modificar.insuranceStatus,
    fullName: modificar.fullName,
    dateOfBirth: modificar.dateOfBirth,
    email: modificar.email,
    phoneNumber: modificar.phoneNumber, 
    mobileNumber: modificar.mobileNumber, 
    currentPcpFullName: modificar.currentPcpFullName,
    lastcurrentPcpFullName: modificar.lastcurrentPcpFullName,
    lastGroupName: modificar.lastGroupName, 
    status: modificar.status,
    medicalCenter: modificar.medicalCenter,
    ReleatedComments: modificar.ReleatedComments || []
  });

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, StaffName: form.currentPcpFullName }];
    setComments(updatedComments);
    handleChange('ReleatedComments', updatedComments)
    setNewComment('');
    setOpenCommentDialog(false);
  };



  const handleSave = () => {
    onSave(form);
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">PCP Changes Detail</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>Edit</Button>
        )}
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item width="100%"><Typography><strong>Member Full Name:</strong> {modificar.fullName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Insurance status:</strong> {form.insuranceStatus}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member ID:</strong> {form.memberId}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>dateOfBirth:</strong> {modificar.dateOfBirth}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Email:</strong> {modificar.email}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Phone Number:</strong> {form.phoneNumber}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Office Location:</strong> {modificar.medicalCenter}</Typography></Grid>
              <TextField
                disabled={!isEditing}
                label="status"
                select
                fullWidth
                value={form.status}
                onChange={e => handleChange('status', e.target.value)}
              >
                {statusMoods.map(opt => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </TextField>
            </Grid>
        </Grid>
      </Paper>

      <Paper variant="outlined" sx={{ p: 4, mb: 3}}>
        <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>
            <Observation cipId={modificar.cipId} />
          </Box>
        </Box>
      </Paper>
      
            
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid item width="100%"><Typography><strong>TimesTamp:</strong> {timestamp}</Typography></Grid>
      </Paper>
      {isEditing && (
          <Box display="flex" justifyContent="flex-end" sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
            }}>
            <Button variant="outlined" onClick={() => setIsEditing(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>Save</Button>
          </Box>
        )}

      {/* Add Comment Dialog */}
      <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)}>
        <DialogTitle>Add Comment</DialogTitle>
        <DialogContent>
          <TextField
            label="Comment"
            fullWidth
            multiline
            rows={4}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentDialog(false)}>Cancel</Button>
          <Button onClick={handleAddComment} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PCPChangesDetail;
